import { inject, injectable } from 'inversify'
import {
  IAppErrorFactory,
  IInvestmentsService,
  IUpdateInvestorUseCase,
  UpdateInvestorUseCaseInput,
  UpdateInvestorUseCaseOutput,
} from '../../types'
import symbols from '../../symbols'
import { getValidUrl } from '../../utils'

@injectable()
export default class UpdateInvestorInteractor implements IUpdateInvestorUseCase {
  @inject(symbols.IInvestmentsService) private investmentsService: IInvestmentsService

  @inject(symbols.IAppErrorFactory) private errorFactory: IAppErrorFactory

  async handle(input: UpdateInvestorUseCaseInput): Promise<UpdateInvestorUseCaseOutput> {
    const output = this.getDefaultOutputData()
    try {
      // URL のプロトコル部分を調整
      input.investment.referenceUrl = getValidUrl(input.investment.referenceUrl)

      output.investment = await this.investmentsService.updateInvestor(input)
    } catch (e) {
      output.error = this.errorFactory.create({
        originalInstance: e as Error,
        messageForUI: '投資家情報の保存に失敗しました',
      })
    }

    return output
  }

  private getDefaultOutputData(): UpdateInvestorUseCaseOutput {
    return {
      investment: null,
      error: null,
    }
  }
}
